import { render, staticRenderFns } from "./modalHistorialRecompensas.vue?vue&type=template&id=d71c41fe&scoped=true&"
import script from "./modalHistorialRecompensas.vue?vue&type=script&lang=js&"
export * from "./modalHistorialRecompensas.vue?vue&type=script&lang=js&"
import style0 from "./modalHistorialRecompensas.vue?vue&type=style&index=0&id=d71c41fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d71c41fe",
  null
  
)

export default component.exports